// extracted by mini-css-extract-plugin
module.exports = {"user":"MessengerSearchItemChat_user__1U2Zc"};